import { DragHandleOutlined } from '@mui/icons-material';
import { styled, svgIconClasses } from '@mui/material';
import { useMemo } from 'react';

import { UseResizeWidthReturn } from '~/hooks/useResizeWidth/useResizeWidth';

const StyledHandle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isResizing',
})<{ isResizing: boolean }>(({ theme, isResizing }) => {
  // Adjusting the color based on active resizing
  // Used to indicate resizing even if mouse is not hovering the svg anymore
  // Same behavior as on MUI DataGrid Column Separator
  const color = useMemo(
    () => (isResizing ? theme.lighten(theme.palette.primary.main, 0.5) : theme.palette.divider),
    [isResizing, theme],
  );

  return {
    // Entire divider is should allow resizing
    position: 'absolute',
    cursor: 'col-resize',
    top: 0,
    bottom: 0,
    // using sufficient width for the cursor to not flicker on resizing
    width: 1,

    // Adjusting the custom handle specifically
    [`& > .${svgIconClasses.root}`]: {
      position: 'relative',
      // Roughly center as (113px / 2) are missing to
      // take overlapping app bar into account
      top: '50%',
      transform: `translate(-25%, calc(-50%)) rotate(90deg)`,
      // apply color for normal state, when active and hovered
      color,
    },

    // highlight handle as soon as area for resizing is hovered
    [`&:hover > .${svgIconClasses.root}`]: {
      color: theme.palette.primary.main,
    },
  };
});

export interface DrawerResizeHandleProps {
  isResizing: UseResizeWidthReturn['isResizing'];
  enableResize: UseResizeWidthReturn['enableResize'];
}

export const DrawerResizeHandle = ({ isResizing, enableResize }: DrawerResizeHandleProps) => {
  return (
    <StyledHandle isResizing={isResizing} onMouseDown={enableResize}>
      <DragHandleOutlined />
    </StyledHandle>
  );
};
